export default {"src":"/_next/static/media/filter.3880ae8d.svg","height":12,"width":16};